(function () {
  var NIF_FIELDS = ['nif_vendedor', 'nif_comprador', 'nif_facturacion'];
  var LETRAS_DNI = 'TRWAGMYFPDXBNJZSQVHLCKE';

  function validarNifCif(value) {
    var v = value.trim().toUpperCase();

    // DNI: 8 dígitos + letra de control
    var mDni = v.match(/^(\d{8})([TRWAGMYFPDXBNJZSQVHLCKE])$/);
    if (mDni) {
      return LETRAS_DNI[parseInt(mDni[1], 10) % 23] === mDni[2];
    }

    // NIE: X/Y/Z + 7 dígitos + letra de control
    var mNie = v.match(/^([XYZ])(\d{7})([TRWAGMYFPDXBNJZSQVHLCKE])$/);
    if (mNie) {
      var nieMap = { X: '0', Y: '1', Z: '2' };
      return LETRAS_DNI[parseInt(nieMap[mNie[1]] + mNie[2], 10) % 23] === mNie[3];
    }

    // CIF: letra de tipo + 7 dígitos + carácter de control (dígito o letra)
    var mCif = v.match(/^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/);
    if (mCif) {
      var digits = mCif[2];
      var sumPar = 0, sumImpar = 0;
      for (var i = 0; i < 7; i++) {
        var d = parseInt(digits[i], 10);
        if (i % 2 === 1) {
          sumPar += d;
        } else {
          var doble = d * 2;
          sumImpar += doble < 10 ? doble : doble - 9;
        }
      }
      var total = sumPar + sumImpar;
      var ctrlNum = (10 - (total % 10)) % 10;
      var ctrlLetra = 'JABCDEFGHI'[ctrlNum];
      var ultimo = mCif[3];
      var tipo = mCif[1];

      // K, P, Q, S → control siempre es letra
      if ('KPQS'.indexOf(tipo) >= 0) return ultimo === ctrlLetra;
      // A, B, E, H → control siempre es dígito
      if ('ABEH'.indexOf(tipo) >= 0) return ultimo === String(ctrlNum);
      // Resto → acepta dígito o letra
      return ultimo === String(ctrlNum) || ultimo === ctrlLetra;
    }

    return false;
  }

  function getWrapper(input) {
    return input.closest
      ? (input.closest('.jet-form-builder__field-wrap') || input.parentNode)
      : input.parentNode;
  }

  function mostrarError(input, mensaje) {
    var wrapper = getWrapper(input);
    var existing = wrapper.querySelector('.nif-error-msg');
    if (!existing) {
      var span = document.createElement('span');
      span.className = 'nif-error-msg';
      span.style.cssText = 'display:block;color:#dc3232;font-size:0.85em;margin-top:4px;';
      wrapper.appendChild(span);
      existing = span;
    }
    existing.textContent = mensaje;
    input.style.borderColor = '#dc3232';
  }

  function limpiarError(input) {
    var wrapper = getWrapper(input);
    var existing = wrapper.querySelector('.nif-error-msg');
    if (existing) existing.textContent = '';
    input.style.borderColor = '';
  }

  function attachValidation(input) {
    input.addEventListener('blur', function () {
      var v = input.value.trim();
      if (!v) { limpiarError(input); return; }
      if (!validarNifCif(v)) {
        mostrarError(input, 'NIF/CIF no válido. Introduce un DNI, NIE o CIF español correcto.');
      } else {
        limpiarError(input);
      }
    });

    input.addEventListener('input', function () {
      limpiarError(input);
    });
  }

  function initNifValidation() {
    NIF_FIELDS.forEach(function (name) {
      var el = document.querySelector('[name="' + name + '"]');
      if (el && !el._nifValidated) {
        el._nifValidated = true;
        attachValidation(el);
      }
    });
  }

  function attachSubmitGuard(form) {
    if (form._nifGuard) return;
    form._nifGuard = true;

    form.addEventListener('submit', function (e) {
      var hasError = false;
      NIF_FIELDS.forEach(function (name) {
        var el = document.querySelector('[name="' + name + '"]');
        if (!el || !el.value.trim()) return;
        if (!validarNifCif(el.value.trim())) {
          mostrarError(el, 'NIF/CIF no válido. Introduce un DNI, NIE o CIF español correcto.');
          hasError = true;
        }
      });
      if (hasError) e.preventDefault();
    }, true);
  }

  function tryAttachSubmitGuard() {
    var form = document.querySelector('form.jet-form-builder__form, form[class*="jet-form"]');
    if (form) { attachSubmitGuard(form); return true; }
    return false;
  }

  function waitAndInit() {
    initNifValidation();
    var guardAttached = tryAttachSubmitGuard();

    var obs = new MutationObserver(function () {
      initNifValidation();
      if (!guardAttached) guardAttached = tryAttachSubmitGuard();
      if (guardAttached) obs.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitAndInit);
  } else {
    waitAndInit();
  }
})();



// WEBPACK FOOTER //
// ./scripts/formularios-itp/form-nif-validation.js